export function initReveal() {
  const { body, documentElement } = document
  const loader = document.querySelector('.openLoader')
  const shell = document.querySelector('.site-shell')
  const wasInert = shell?.inert
  const heroBlocks = Array.from(document.querySelectorAll('.pz-hero .inview'))
  const blocks = Array.from(document.querySelectorAll('.inview')).filter(
    (element) => !element.closest('.pz-hero'),
  )
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  const openingLeadTime = 500 // FVの全表示完了より早める時間（ms）
  let observer
  let openingTimer
  let openingComplete = false

  // FVの表示中は、Tabキーによる画面外へのフォーカス移動も止める。
  if (shell) shell.inert = true

  const reveal = (element) => element.classList.add('is-view')
  const revealAll = () => {
    observer?.disconnect()
    blocks.forEach(reveal)
  }

  // キーボードで移動した先も、スクロール監視の通知を待たず表示する。
  body.addEventListener('focusin', (event) => {
    if (!openingComplete) return
    const block = event.target.closest('.inview')
    if (block && !block.closest('.pz-hero')) reveal(block)
  })

  const completeOpening = () => {
    if (openingComplete) return
    window.clearTimeout(openingTimer)
    openingComplete = true
    documentElement.classList.add('is-fv-complete')
    if (shell) shell.inert = wasInert

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      revealAll()
      return
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          reveal(entry.target)
          observer.unobserve(entry.target)
        })
      },
      { threshold: 0, rootMargin: '0px 0px -5% 0px' },
    )
    blocks.forEach((block) => observer.observe(block))
  }

  const onLoaded = () => {
    body.classList.add('is-loaded')
    loader?.setAttribute('aria-hidden', 'true')

    // CSSのdelayとdurationに追従し、全表示完了の0.5秒前に解除する。
    const animations = heroBlocks.flatMap((element) => element.getAnimations?.() || [])
    const remainingTime = Math.max(
      0,
      ...animations.map(
        (animation) =>
          animation.effect.getComputedTiming().endTime - (animation.currentTime || 0),
      ),
    )
    openingTimer = window.setTimeout(
      completeOpening,
      Math.max(0, remainingTime - openingLeadTime),
    )

    // reduced-motionへの切替などで中断された場合もロックを解除する。
    Promise.all(animations.map((animation) => animation.finished.catch(() => {}))).then(
      completeOpening,
    )
  }

  reducedMotion.addEventListener('change', (event) => {
    if (event.matches && openingComplete) revealAll()
  })

  // 遅延実行やキャッシュ復元でもloadイベントを取り逃がさない。
  if (document.readyState === 'complete') onLoaded()
  else window.addEventListener('load', onLoaded, { once: true })
}
